var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('website-landing'),_c('project-gallery'),_c('about-me'),_c('footer',{staticClass:"footer text-smaller text_align_center"},[_vm._v("\n    All works@Poulami "+_vm._s(_vm.year)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }